import React from 'react';

import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import SearchInput from 'search/inputs/SearchInput';
import {StandardFilter, Operator, isStandardFilterArrayValue} from 'search/SearchConstants';
import {typeToName} from 'util/NameUtil';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import OperatorDropdown from './base/OperatorDropdown';
import SecondaryFilterFormSkeleton from './base/SecondaryFilterFormSkeleton';

export interface RequestV2SubmissionFilterFormProps extends BaseFilterFormProps {
  filter: StandardFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: StandardFilter) => void;
  onRemove: () => void;
  operators: Array<Operator>;
  onChangeOperator: (value: Operator) => void;
  selectedOperator: Operator;
}

export default function RequestV2SubmissionFilterForm(
  props: RequestV2SubmissionFilterFormProps
): JSX.Element {
  assert(
    props.filterStyle === FilterStyle.SECONDARY,
    'Request V2 Submission filter only configured to work as secondary filter'
  );

  const getCurrentFilterValue = (): Array<string | null> => {
    const value = props.filter.value;
    assert(isStandardFilterArrayValue(value), 'Request V2 Submission filter value must be an array');
    return value as Array<string | null>;
  };

  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const operatorDropdown = (
    <OperatorDropdown
      buttonSize={props.buttonSize}
      onChangeOperator={props.onChangeOperator}
      operators={props.operators}
      selectedOperator={props.selectedOperator}
    />
  );

  const searchInput = (
    <SearchInput
      autoFocus={false}
      isMulti={true}
      onSelect={(id) => {
        const value = getCurrentFilterValue();
        const newValue = value.includes(id) ? value : [...value, id];
        props.onChangeFilter({
          ...props.filter,
          value: newValue,
        });
      }}
      onRemove={(id) => {
        const value = getCurrentFilterValue();
        const newValue = value.filter((prevId) => prevId !== id);
        props.onChangeFilter({
          ...props.filter,
          value: newValue,
        });
      }}
      placeholder={`Search for a ${typeToName(ModelTypeConstants.REQUEST_V2_SUBMISSION)}`}
      selected={getCurrentFilterValue()}
      types={[ModelTypeConstants.REQUEST_V2_SUBMISSION]}
    />
  );
  return (
    <SecondaryFilterFormSkeleton
      {...skeletonProps}
      nodeGrid={[[operatorDropdown], [searchInput]]}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      onRemove={props.onRemove}
    />
  );
}
